import { render, staticRenderFns } from "./SalesSpeedCard.vue?vue&type=template&id=0bc8d885&"
import script from "./SalesSpeedCard.vue?vue&type=script&lang=js&"
export * from "./SalesSpeedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports